import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { OtaBatchPageComponent } from './ota-batch-page.component';

const routes: Routes = [
  {
    path: 'ota-batch-page',
    data: { name: 'Device Batch', isTab: false },
    component: OtaBatchPageComponent,
  },
  {
    path: 'ota-batch-page/:uid',
    component: OtaBatchPageComponent,
  },
];
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class OtaBatchPageRoutingModule {}
